import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import './filter.css';
import AuthContext from '../../context/AuthContext';

const PlayerFilter = ({ onPlayerSelect }) => {
  const [players, setPlayers] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState('');
  const [showPlayers, setShowPlayers] = useState(false);
  const [filterLabel, setFilterLabel] = useState('Filter by'); // Initial label
  const [lastClickedPlayer, setLastClickedPlayer] = useState(''); // State to store the last clicked player
  const { authTokens } = useContext(AuthContext);

  const headers = {
    Authorization: `Bearer ${authTokens.access}`,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_BACKEND + "users/list-players", { headers });
        const fetchedData = response.data;
        setPlayers(fetchedData);
      } catch (error) {
        console.error('Error fetching players:', error);
      }
    };

    const fetchData2 = async () => {
      try {
        const response2 = await axios.get(process.env.REACT_APP_BACKEND + 'evaluations', { headers });
        const fetchedData2 = response2.data;
      } catch (error) {
        console.error('Error fetching players:', error);
      }
    };

    fetchData();
    fetchData2();
  }, []);

  const handlePlayerSelection = (playerId, playerName, positionAcronym) => {
    setSelectedPlayer(playerId);
    setFilterLabel(`${playerName} (${positionAcronym})`); // Update label to include position_acronym
    setShowPlayers(false);
    setLastClickedPlayer(playerName);
    onPlayerSelect(playerName);
  };

  return (
    <div className='filter-by-dashboard'>
      <label>{lastClickedPlayer || filterLabel}</label>
      <button onClick={() => setShowPlayers(!showPlayers)}>
        &lt;
      </button>
      {showPlayers && (
        <div className="player-list-filtro">
          <div className="header-filtro">
            <p className="player-list-title-filtro">Nome Jogador</p>
            <p className="position-title-filtro">Posição</p>
          </div>
          <div className="separator-filtro" />
          <div className="player-info-filtro">
            {players.map((player) => (
              <div
                key={player.id}
                className="player-filtro"
                onClick={() =>
                  handlePlayerSelection(
                    player.id,
                    `${player.user.first_name} ${player.user.last_name}`,
                    player.position_acronym
                  )
                }
              >
                <p className="nomes-jogadores-filtro">{player.user.first_name} {player.user.last_name}</p>
                <p className="position-acronym-filtro">{player.position_acronym}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <select
        value={selectedPlayer}
        onChange={(e) => setSelectedPlayer(e.target.value)}
        style={{ display: 'none' }}
      >
        <option value="">Select a player</option>
        {players.map((player) => (
          <option key={player.id} value={player.id}>
            {player.user.first_name} {player.user.last_name} ({player.position_acronym})
          </option>
        ))}
      </select>
    </div>
  );
};

export default PlayerFilter;
